<template>
	<div >
		<div class="module_title05">
			<span>近30天行停分析：</span>
		</div>
		<div class="ibox-content alarm_info_list" style="height:400px;">
			<div style="width:100%;height:300px;">
				<pie-r-s-chart 
				v-if="showPie" 
				:itemOn="itemOn" 
				:itemOff="itemOff" 
				:cntOn="cntOn" 
				:cntOff="cntOff" 
				:hasRefresh="false"
				></pie-r-s-chart>
			</div>
			<div class="monitor_text_tip">
				<span>行驶：{{this.dayInfo[0].runTime2}}</span>
			</div>
			<div class="monitor_text_tip">
				<span>停车：{{this.dayInfo[0].stopTime2}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import PieRSChart from 'components/modules/bulletin/PieRSChart'
	export default {
		name: 'PieRunStop',
		components: {
			PieRSChart
		},
		data() {
			return {
				pie: {},
				itemOn: '行驶',
				itemOff: '停车',
				showPie: false,
				cntOn: 0,
				cntOff: 0
			}
		},
		props: ['dayInfo'],
		mounted() {
			this.cntOn = this.dayInfo[0].runTime
			this.cntOff = this.dayInfo[0].stopTime
			this.showPie = true;
		}
	}
</script>


// WEBPACK FOOTER //
// PieRunStop.vue?717e56a7